import { render, staticRenderFns } from "./InputWithVars.vue?vue&type=template&id=6fcd8240&"
import script from "./InputWithVars.vue?vue&type=script&lang=js&"
export * from "./InputWithVars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports